import { WorkflowStepType, type WorkflowConfig } from "@validereinc/domain";

export function validateAllStepIdsAreUnique(
  steps: WorkflowConfig["steps"],
  stepIds = new Set<string>()
) {
  for (const [id, step] of Object.entries(steps)) {
    if (stepIds.has(id)) {
      throw new Error("Step ID must be unique");
    }
    stepIds.add(id);
    if (step.type === WorkflowStepType.PARALLEL) {
      for (const branch of step.branches) {
        validateAllStepIdsAreUnique(branch.steps, stepIds);
      }
    }
  }
}
